export const LOCALE_PL = {
    ORDER: "Zamówienie",
    INVOICE: "Rachunek",
    INVOICES: "Rachunki",
    PROFORMA_INVOICES: "Faktury pro forma",
    CREDIT_NOTE: "Zapis na dobro rachunku",
    CREDIT_NOTES: "Noty kredytowe",
    CREATION_DATE: "Data wystawienia",
    DELIVERY_DATE: "Data dostawy",
    DELIVERY_ADDRESS: "Adres dostawy",
    DELIVERY_COST: "Opłata za dostawę",
    VENDOR: "Dostawca",
    CUSTOMER: "Klient",
    ORDER_NUMBER: "Numer zamówienia",
    PAYMENT_METHOD: "Forma płatności",
    NOTE: "Notatka",
    PRODUCT: "Artykuł",
    PRODUCT_DESCRIPTION: "Opis",
    PRODUCT_AMOUNT: "Ilość",
    PRODUCT_SINGLE_PRICE: "Cena jednostkowa",
    DISCOUNT: "Zniżka",
    TOTAL_DISCOUNTS: "Kwota Zniżka",
    TOTAL_BEFORE_DISCOUNTS: "Kwota bez zniżka",
    TAX_ABBREVIATED: "VAT",
    TAX_AMOUNT: "Kwota podatku",
    SPLIT_AMOUNT: "Kwota podziału",
    BRUTTO: "Brutto",
    TOTAL: "Razem",
    TOTAL_INCLUDING_VAT: "Razem z VAT",
    TOTAL_EXCLUDING_VAT: "Razem bez VAT",
    VAT_ID: "NIP",
    TAX_ID: "NIP",
    PAID: "Zapłacono",
    UNPAID_AMOUNT: "Kwota niezapłacona",
    REASON: "Powód",
    INVOICE_LINE_ITEMS_TITLE: "Pozycje zamówienia",
    CREDIT_NOTES_LINE_ITEMS_TITLE: "Zapisy na dobro rachunku na pozycjach zamówienia",
    OTHER_CREDIT_NOTES: "Korekta zamówienia",
    REFUND_SHIPPING_COST: "Koszty przesyłki zwrotnej",
    REFUND_HAS_BEEN_PAID: "Wypłacono zwrot w wysokości $VALUE.",
    REFUND_HAS_BEEN_PAID_FAILED: "Zwrot płatności w wysokości $VALUE nie powiódł się.",
    DOCUMENTS_FOR_ORDER: "Dokumenty do zamówienia",
    NO_INVOICES: "Nie ma jeszcze faktur",
    NO_CREDIT_NOTES: "Nie ma jeszcze not kredytowych",
    DOCUMENTS_ARE_GENERATING: "Dokumenty są generowane. Proszę spróbować ponownie za kilka minut.",
    INVALID_REQUEST_PATHWAY_SUPPORT:
        "Nie udało nam się znaleźć żadnych dokumentów do tego zamówienia. Prosimy o wysłanie wiadomości na adres support@pathway-solutions.de.",
    INVALID_REQUEST_GENERIC:
        "Nie udało nam się znaleźć żadnych dokumentów do tego zamówienia. Proszę wysłać maila do sprzedawcy",
    INVALID_REQUEST_INDIVIDUAL_SUPPORT:
        "Nie udało nam się znaleźć żadnych dokumentów do tego zamówienia. Prosimy o wysłanie maila na adres ${MAIL}",
    GIFT_CARD_LINE: "Do tego zamówienia użyto kodu kuponu${GIFT_CARD_CODE} na ${GIFT_CARD_AMOUNT}",
    GIFT_CARD: "Kuponu",
    REVERSAL_INVOICE: "Faktura anulowania",
    REVERSAL_CREDIT_NOTE: "Anulowanie noty kredytowej",
    DUTY: "Opłata celne",
    USED_DISCOUNTS: "Zastosowane rabaty",
    PAYMENT_AT: "Płatność w dniu $DATE",
    REFUNDED_CREDITNOTE_AT: "Zwrot noty kredytowej $CREDIT_NOTE w dniu $DATE",
    REFUNDED_AT: "Zwrot w dniu $DATE",
    PROCESSING_DOCUMENT: "Dokument jest przetwarzany",
    DOWNLOAD_DOCUMENTS_TITLE: "Pobierz tutaj swoje dokumenty!",
    MAIL_INTRODUCTION: "W przypadku pytań prosimy o kontakt na adres ${MAIL}",
    REPAYMENT_DIFFERENCE: "Różnica do zwrotu",
    DOCUMENT_PREVIEW_BANNER: "Podgląd – pobierz PDF",
};
